module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Pride-And-Prejudice-landscape.c11424b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Pride-And-Prejudice-landscape.jpg
// module id = p9VL
// module chunks = 0